export default __webpack_public_path__ + "static/media/No-Data-Found.d931f8e8.png";